module.exports = __webpack_public_path__ + "img/3.d9e09a9a.jpg";